<script setup lang="ts">

</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="w-full h-auto"
       viewBox="0 0 290.623 125.203">
    <g transform="translate(-754 -310.459)">
      <g transform="translate(754 310.459)">
        <g>
          <path
                d="M207.016,42.55l65.455-.011c18.164,2,24.769,25.129,10.152,36.407-2.185,1.686-7.142,4.07-9.884,4.07H207.016v5.721l-33.893,36.156c-17.953.575-36.082.167-54.1.207L81.989,89.016v-6l-63.222.011C2.222,81.73-6.04,61.849,5.1,49.244c2.473-2.8,8.483-6.694,12.283-6.694H81.989V36.829Q98.6,19.531,115.357,2.375c.32-.328.772-.816.953-1.018.145-.161.9-1.026,1.149-1.058a23.929,23.929,0,0,1,3.17-.153c15.251-.153,30.542-.126,45.793,0,1.333.011,2.82-.463,4.191.247l36.4,36.715ZM163.2,4.316H124.409l20.195,18.4Zm4.186,29.3V6.27L148.128,25.384Zm-45.487.558,19.527-8.512-21.2-19.115Zm77.86,1.674L171.573,7.386V35.852Zm-81.77,0L116.034,7.666,88.687,35.852Zm50.159,2.866L145.2,28.858l-23.235,9.855-10.671,21.86,10.75,25.507,23.161,8.671,21.827-8.74,10.845-22.667Zm-51.554,1.321H89.245L107.8,58.181Zm82.607,0H173.247L181.2,59.847Zm3.628,43.536V42.55L185.009,62.176ZM86.175,83.016l19.53-20.791L86.175,43.108Zm-4.186-36.28H17.662a20.772,20.772,0,0,0-4.57,1.57,16.186,16.186,0,0,0-1.913,27.8c1.565,1.066,5.2,2.727,7.041,2.727H81.989Zm191.028,0h-66V78.83h65.444c6.119,0,12.628-7.072,13.742-12.77,1.674-8.557-4.256-18.265-13.184-19.324M199.2,86.365,181.623,64.877l-10.05,21.488Zm-110.235,0h28.466l-8.794-20.934Zm29.024,4.186H89.524l28.466,27.908Zm49.4,0L148.131,98.09l19.256,18.974Zm32.094,0H171.573v29.861Zm-77.3.279v25.954l19.256-18.974Zm2.233,30.14h41.024L144.642,100.6Z"
                transform="translate(0 0)"/>
        </g>
      </g>
      <g transform="matrix(0.469, -0.883, 0.883, 0.469, 928.439, 418.901)" fill="#fff" stroke="#000"
         stroke-width="4">
        <ellipse cx="9" cy="11.5" rx="9" ry="11.5" stroke="none"/>
        <ellipse cx="9" cy="11.5" rx="7" ry="9.5" fill="none"/>
      </g>
      <g transform="matrix(0.469, 0.883, -0.883, 0.469, 948.746, 316.008)" fill="#fff" stroke="#000"
         stroke-width="4">
        <ellipse cx="9" cy="11.5" rx="9" ry="11.5" stroke="none"/>
        <ellipse cx="9" cy="11.5" rx="7" ry="9.5" fill="none"/>
      </g>
      <g transform="matrix(-0.469, -0.883, 0.883, -0.469, 847.27, 429.699)" fill="#fff" stroke="#000"
         stroke-width="4">
        <ellipse cx="9" cy="11.5" rx="9" ry="11.5" stroke="none"/>
        <ellipse cx="9" cy="11.5" rx="7" ry="9.5" fill="none"/>
      </g>
      <g transform="matrix(-0.469, 0.883, -0.883, -0.469, 867.578, 326.806)" fill="#fff" stroke="#000"
         stroke-width="4">
        <ellipse cx="9" cy="11.5" rx="9" ry="11.5" stroke="none"/>
        <ellipse cx="9" cy="11.5" rx="7" ry="9.5" fill="none"/>
      </g>
    </g>
  </svg>

</template>

<style scoped>

</style>